module.exports = __webpack_public_path__ + "img/img_device_zt101.f6d48d12.png";